import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { ReceptionPanePatientFragment } from '~/graphql/generated/graphql';
import { useMedixsSetting } from '~/hooks/use-medixs-setting';
import { medixsReceptionIdentificationModalState } from '~/state/partials/medixs_reception_identification_modal/atoms';

type Props = {
  patient: ReceptionPanePatientFragment | undefined | null;
  appointmentId: string;
};

export const useLinkMedixsPatient = ({ patient, appointmentId }: Props) => {
  const { medixsSetting } = useMedixsSetting();
  const setMedixsReceptionIdentificationModalState = useSetAtom(
    medixsReceptionIdentificationModalState,
  );

  const openMedixsReceptionIdentificationModal = useCallback(() => {
    setMedixsReceptionIdentificationModalState({
      isOpen: true,
      error: null,
      patientId: patient?.id || null,
      appointmentId: appointmentId,
      medixsSettingId: medixsSetting?.id || null,
      selectedMedixsReception: null,
      selectedDate: null,
    });
  }, [appointmentId, medixsSetting?.id, patient?.id, setMedixsReceptionIdentificationModalState]);

  return { openMedixsReceptionIdentificationModal };
};
